export const ACCOUNTS_TABLE_TITLE = 'Accounts';
export const ACCOUNTS_TABLE_INFO_URL = '';
